<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <p class="text-center">
          <img src="@/assets/logo.png" width="200" height="200" />
        </p>
        <v-card flat v-if="!newPassRequired">
          <v-form v-model="valid" @submit.prevent="forgot">
            <v-card-text>
              <p class="lead">パスワードを忘れた方へ</p>
              <p>
                ご利用いただいているメールアドレスを入力してください。<br />
                e-mailにてパスワードリセット用の認証コードを送信します。
              </p>
              <v-text-field ref="username" prepend-icon="fas fa-envelope" name="username" label="メールアドレス" type="text" v-model="editedItem.username" :rules="[rules.required, rules.email]"></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn type="submit" color="primary" :disabled="!valid" :loading="loading">
                <v-icon left>fas fa-redo-alt</v-icon>パスワードのリセット
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
            <p class="text-center mt-5">
              <router-link to="/login">ログインページ</router-link>
            </p>
          </v-form>
        </v-card>

        <v-card flat v-if="newPassRequired">
          <v-form v-model="newpassValid" @submit.prevent="newPass">
            <v-card-text>
              <p>e-mailにて送信された認証コードと新しいパスワードを入力してください。</p>
              <v-text-field
                ref="code"
                v-model="editedItem.code"
                label="認証コード"
                :rules="[rules.required]"
                prepend-icon="fas fa-key"></v-text-field>
              <v-text-field
                ref="newpass"
                v-model="editedItem.newpass"
                type="password"
                label="新しいパスワード"
                :rules="[rules.required, rules.min8Char]"
                prepend-icon="fas fa-lock"></v-text-field>
              <v-text-field
                ref="newpassConfirm"
                v-model="editedItem.newpassConfirm"
                type="password"
                label="新しいパスワード（確認）"
                :rules="[rules.required, rules.min8Char, confirm]"
                prepend-icon="fas fa-lock"></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn type="submit" color="primary" :disabled="!newpassValid" :loading="loading">
                <v-icon left>fas fa-sign-in-alt</v-icon>パスワードリセット
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-form>
        </v-card>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { Auth } from 'aws-amplify'

export default {
  data() {
    return {
      editedItem: {
        username: null,
        code: null,
        newpass: null,
        newpassConfirm: null,
      },
      valid: false,
      loading: false,
      newpassValid: false,
      newPassRequired: false,
    }
  },
  props: {

  },
  computed: {
    form() {
      let form = Object.assign({}, this.editedItem)
      return form
    },
    confirm() {
      if (this.editedItem.newpass) {
        return this.editedItem.newpass == this.editedItem.newpassConfirm ? true : 'パスワードが一致しません'
      } else {
        return true
      }
    }
  },
  methods: {
    //メールアドレスの入力
    async forgot() {
      try {
        this.loading = true
        //メールアドレスの照合とコードの送信
        await Auth.forgotPassword(this.editedItem.username)
        //コードの送信成功
        this.newPassRequired = true
        //this.$refs['username'].reset()

        this.loading = false
      } catch (error) {
        console.log(error)
        this.invalid('このメールアドレスは使用されていません。')
      }
    },
    //新しいパスワードの設定
    async newPass() {
      try {
        this.loading = true
        //パスワードリセット
        await Auth.forgotPasswordSubmit(
          this.editedItem.username,
          this.editedItem.code,
          this.editedItem.newpass
        )
        //リセット成功
        this.myAlert('パスワードをリセットしました', 'success')
        this.success()

      } catch (error) {
        console.log(error)
        this.invalid('認証コードが正しくありません。')
      }
    },
    success() {
      this.$router.push('/login')
    },
    invalid(mess) {
      this.loading = false
      this.myAlert(mess)
    }
  }
}
</script>

<style scoped>
p.lead {
  font-size: 20px;
  font-weight: bold;
}
</style>
